import React from 'react';
import ContentLoader from 'react-content-loader';

interface Props {}

const UserLoader: React.FC<Props> = (props) => {
  return (
    <div className="ceas-flex ceas-justify-center">
      <ContentLoader
        speed={3}
        width={400}
        height={460}
        viewBox="0 0 400 460"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
      >
        <circle cx="194" cy="213" r="157" />
        <rect x="76" y="384" rx="0" ry="0" width="241" height="17" />
      </ContentLoader>
    </div>
  );
};

export default UserLoader;
